const platform = {
    title: 'Paramètres de la plateforme',
    subtitle: 'Gérez les administrateurs inter-locataires et l’apparence globale.',
    branding_title: 'Marque de la plateforme',
    branding_description: 'Appliquée à la console, l’authentification, le centre de compte, les démos et l’aide.',
    product_name: 'Nom du produit',
    slogan: 'Slogan',
    light_logo: 'Logo du thème clair',
    dark_logo: 'Logo du thème sombre',
    upload_logo: 'Téléverser le logo',
    uploading: 'Téléversement…',
    logo_uploaded: 'Logo téléversé',
    hide_open_source_notice: 'Masquer la mention open source',
    hide_open_source_notice_description: 'Masque les liens d’attribution visibles tout en conservant les fichiers de licence et de source.',
    save: 'Enregistrer',
    saving: 'Enregistrement…',
    saved: 'Marque de la plateforme enregistrée',
    administrators_title: 'Administrateurs de la plateforme',
    administrators_description: 'Ils peuvent gérer tous les locataires et paramètres de l’instance.',
    administrator_identifier_placeholder: 'ID, nom d’utilisateur ou e-mail',
    add_administrator: 'Ajouter un administrateur',
    administrator_added: 'Administrateur ajouté',
    remove_administrator: 'Retirer l’administrateur',
};
export default Object.freeze(platform);
